import { DialogActions, DialogContent, DialogTitle } from '@mui/material';
import { DEFAULT_ADVANCE_BUTTON_STYLE, DEFAULT_CANCEL_BUTTON_STYLE } from '../../../utils/styleHelpers';
import { GridPreferences, UserPreferences } from '../../../store/User';
import { CustomizeTableColumns } from '../../Compounds/CustomizeTableColumns/CustomizeTableColumns';
import { CustomizeDashboardWidgets } from '../../Compounds/CustomizeDashboardWidgets/CustomizeDashboardWidgets';
import { Dispatch, SetStateAction } from 'react';

export interface SettingsFormProps {
  customizations: UserPreferences;
  title: string;
  onCancel: () => void;
  onSave: () => void;
  saveDisabled: boolean;
  setNewUserPreferences: Dispatch<SetStateAction<UserPreferences>>;
}

export const SettingsForm = ({
  customizations,
  title,
  onCancel,
  onSave,
  saveDisabled,
  setNewUserPreferences
}: SettingsFormProps) => {
  const handleSetGridPreferences = (prefs: GridPreferences) => {
    setNewUserPreferences({
      ...customizations,
      content: { ...customizations.content, inventory_grid_All: prefs }
    });
  };

  return (
    <>
      <div className="flex flex-col px-3 max-w-xl m-auto py-3">
        <DialogTitle>{`${title} ${title === 'Inventory' ? 'Grid' : ''} Settings`}</DialogTitle>
        <DialogContent tabIndex={-1}>
          <div className="flex flex-col items-center h-96">
            <div className="flex flex-col">
              {title === 'Inventory' && (
                <CustomizeTableColumns
                  gridPreferences={customizations.content.inventory_grid_All}
                  setGridPreferences={(v) => handleSetGridPreferences(v as GridPreferences)}
                  type="user"
                />
              )}
              {title === 'Widgets' && (
                <CustomizeDashboardWidgets
                  userPreferences={customizations}
                  setUserPreferences={(v) => setNewUserPreferences(v as UserPreferences)}
                  drawer={false}
                  widgetKey="home"
                />
              )}
            </div>
          </div>
        </DialogContent>
      </div>
      <DialogActions className="flex mx-4 mb-3 space-x-4">
        <button
          className={DEFAULT_CANCEL_BUTTON_STYLE}
          onClick={onCancel}>
          Cancel
        </button>
        <button
          className={DEFAULT_ADVANCE_BUTTON_STYLE}
          onClick={onSave}
          disabled={saveDisabled}>
          Set
        </button>
      </DialogActions>
    </>
  );
};
